/**
 * SoftButton — pill button matching the UnAnonymous design system.
 * Variants: primary (deep plum), secondary (oat fill), ghost, safe (forest green).
 */
export default function SoftButton({
  children,
  variant = "primary",
  size = "md",
  className = "",
  iconLeft,
  iconRight,
  ...rest
}) {
  const sizes = {
    sm: "px-4 py-2 text-sm",
    md: "px-5 py-3 text-[15px]",
    lg: "px-6 py-4 text-base",
  };

  const variants = {
    primary: {
      background: "linear-gradient(105deg, var(--un-plum-deep), var(--un-plum-hover))",
      color: "#FDFBF7",
      boxShadow: "0 12px 28px rgba(74,45,72,0.20)",
    },
    secondary: {
      background: "rgba(91,57,84,0.07)",
      color: "var(--un-text-1)",
      boxShadow: "0 4px 16px rgba(74,45,72,0.06)",
    },
    ghost: {
      background: "transparent",
      color: "var(--un-text-2)",
      boxShadow: "none",
    },
    safe: {
      background: "var(--un-safe)",
      color: "#FDFBF7",
      boxShadow: "0 10px 28px rgba(62,92,80,0.22)",
    },
    outline: {
      background: "transparent",
      color: "var(--un-text-1)",
      boxShadow: "inset 0 0 0 1.5px rgba(91,57,84,0.18)",
    },
  };

  return (
    <button
      {...rest}
      style={{ ...variants[variant], fontFamily: "Manrope, sans-serif" }}
      className={`${sizes[size]} rounded-full inline-flex items-center justify-center gap-2 font-medium tracking-tight un-press transition-all duration-200 hover:brightness-105 disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {iconLeft}
      {children}
      {iconRight}
    </button>
  );
}
